module.exports = __webpack_public_path__ + "static/media/eas.f276752f.svg";